import React, { useEffect, useState } from "react"
import { Button } from "antd"
import { MenuOutlined, DragOutlined } from "@ant-design/icons"
import Draggable, { DraggableData } from "react-draggable"
import "./DraggableMenuButton.less"
import useDebounce from "../../hooks/useDebounce"
import useMenuPosition from "../../hooks/useMenuPosition"
export default function DraggableMenuButton({
  onClick,
}: {
  onClick: () => void
}) {
  const [menuPosition, setMenuPosition] = useMenuPosition()
  const [position, setPosition] = useState(menuPosition)
  const debouncedPosition = useDebounce(position, 1000)
  function handleStop(data: DraggableData) {
    setPosition({
      x: data.x,
      y: data.y,
    })
    // setPosition({
    //   x:
    //     window.innerWidth / 2 > data.x
    //       ? 0
    //       : window.innerWidth - data.node.offsetWidth,
    //   y: data.y,
    // });
  }
  useEffect(() => {
    if (
      position.x > window.innerWidth ||
      position.x < 0 ||
      position.y > window.innerHeight ||
      position.y < 0
    ) {
      setPosition({ x: 0, y: 0 })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  useEffect(() => {
    setMenuPosition(position)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedPosition])
  return (
    <Draggable
      bounds="body"
      handle="strong"
      position={position}
      defaultClassNameDragged="menu-dragged"
      defaultClassNameDragging="menu-dragging"
      scale={1}
      onStop={(e, data) => handleStop(data)}
    >
      <div className="draggable-menu-wrapper">
        <Button
          // size="middle"
          type="primary"
          className="draggable-menu-btn"
          onClick={() => onClick()}
          icon={<MenuOutlined />}
        />
        <strong className="draggable-menu-handler">
          <DragOutlined />
        </strong>
      </div>
    </Draggable>
  )
}
